import { Injectable } from '@angular/core';

@Injectable()
export class HelperService {

 merge = (target: any, ...sources: any[]) => Object.assign(target, ...sources);

 clone<T>(source: T): T {
    return Object.assign({}, source);
  }

 cloneDeep<T>(source: T): T {
    return JSON.parse(JSON.stringify(source));
  }

  equal = (entityA: {}, entityB: {}) => Object.keys(entityA).find(key => entityA[key] === entityB[key]);

  deepCopy(obj: any): any {

    var copy;

    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) return obj;

    // Handle Date
    if (obj instanceof Date) {
        copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
        copy = [];
        for (var i = 0, len = obj.length; i < len; i++) {
            copy[i] = this.deepCopy(obj[i]);
        }
        return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
        copy = {};
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr)) copy[attr] = this.deepCopy(obj[attr]);
        }
        return copy;
    }

    throw new Error("Unable to copy obj! Its type isn't supported.");
   
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/common/service/model-helper.service.ts